module.exports = "pegasus_template/assets/two-column-text-second-larger-preview.png";